import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { EmailTemplatesPanel } from "@/components/admin/email/EmailTemplatesPanel";

export const Route = createFileRoute("/_authenticated/admin/email/templates")({
  head: () => ({
    meta: [
      { title: "Админ — Имейл · Шаблони | FIXHEN" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <AdminLayout>
      <EmailTemplatesPanel />
    </AdminLayout>
  ),
});
